import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';
import axios from 'axios';
import options from 'config';
import { refreshUserToken } from '@/resources/auth.js';

/**
 * RestAPIV4 - basic wrapper over XMLHttpRequest for using V4 API
 *
 * @param {string} baseURL - base url
 * @constructor
 */
export function RestAPIV4(baseURL) {
    REST.call(this, axios, baseURL);

    this.api.interceptors.response.use((response) => response.data.result || response.data,
        (error) => {
            // If a request 401s, refresh the token and then replay the request
            if (error.config && !error.config.hasRetried && error.response && error.response.status === 401) {
                return refreshUserToken().then(() =>
                    // if success then replay request
                    this.api.request({
                        ...error.config,
                        hasRetried: true,
                    }),
                );
            }

            return Promise.reject(error);
        });
}

export const sendBeaconDeleteBatch = (batch_uuid) => {
    navigator.sendBeacon(`${options.console_api_url}/batch/${batch_uuid}/delete`);
};

export const sendAnalyticsBeacon = (event) => {
    navigator.sendBeacon(
        `${options.console_api_url}/analytics/users/event`,
        new Blob([ JSON.stringify(event) ], {
            type: 'application/json;charset=UTF-8',
        }),
    );
};

RestAPIV4.prototype = Object.create(REST.prototype);

export const restAPIV4 = flyweight(RestAPIV4);
